import { ReactComponent as AlertCircle } from "../../assets/icons/alert-circle.svg";
import { ReactComponent as CheckCircleSolid } from "../../assets/icons/check-circle-solid.svg";
import { ReactComponent as CrossCircle } from "../../assets/icons/cross-circle.svg";

export const icons = {
  alertCircle: AlertCircle,
  checkSolid: CheckCircleSolid,
  cross: CrossCircle,
};
